import { PaginationWithoutCacheProps, PaginationResult } from './interface';
import _ from 'lodash';

const useBusinessLogic = ({
  totalCount,
  maxItemPerPage,
  currentPageNumber,
  itemCountPerPage,
  showItemsMaxCountAroundCurrentPage = 2, // デフォルトは既存のページングコンポーネントと合わせ、2とします
  onSelectPageNumber,
}: PaginationWithoutCacheProps): PaginationResult => {
  /**
   * ページングコンポーネントの表示判定(総件数0件の場合はコンポーネントを描画しない)
   */
  const isShowComponent = totalCount !== 0;
  /**
   * ページ表示データの1件目の件数
   */
  const currentPageFirstItemIndex = maxItemPerPage * (currentPageNumber - 1) + 1;
  /**
   * ページ表示データの最後のデータの件数
   */
  const currentPageLastItemIndex =
    itemCountPerPage < maxItemPerPage ? maxItemPerPage * (currentPageNumber - 1) + itemCountPerPage : maxItemPerPage * currentPageNumber;
  /**
   * 現在表示中のデータの件数サマリ
   */
  const summaryLabel = `検索結果 : ${currentPageFirstItemIndex}〜${currentPageLastItemIndex} / ${totalCount}件`;

  /**
   * 最終ページ数(総ページ数)
   */
  const totalPages = Math.ceil(totalCount / maxItemPerPage);

  /**
   * prevボタン表示フラグ
   */
  const showPrevPageButton = currentPageNumber > 1;
  /**
   * nextボタン表示フラグ
   */
  const showNextPageButton = currentPageNumber !== totalPages;

  /**
   * first(1ページ目) , last(最終ページ)以外のページ数の配列
   */
  const visibleMiddlePages: number[] = [];
  if (currentPageNumber === 1) {
    for (let i = currentPageNumber + 1; i <= currentPageNumber + showItemsMaxCountAroundCurrentPage; i++) {
      // 総ページ数に到達した場合は終了
      if (i >= totalPages) break;
      visibleMiddlePages.push(i);
    }
  } else if (currentPageNumber === totalPages) {
    for (let i = totalPages - showItemsMaxCountAroundCurrentPage; i < totalPages; i++) {
      // 1ページ目である場合はskip
      if (i <= 1) continue;
      visibleMiddlePages.push(i);
    }
  } else {
    for (let i = currentPageNumber - showItemsMaxCountAroundCurrentPage; i <= currentPageNumber + showItemsMaxCountAroundCurrentPage; i++) {
      // 1ページ目である場合はskip
      if (i <= 1) continue;
      // 総ページ数に到達した場合は終了
      if (i >= totalPages) break;
      visibleMiddlePages.push(i);
    }
  }
  /**
   * 画面に表示するページングボタンの配列(1ページ目と最終ページは必ず表示する)
   */
  const visiblePages: number[] = _.sortedUniq([1, ...visibleMiddlePages, totalPages]);

  const handleClickPrevButton = () => onSelectPageNumber(currentPageNumber - 1);
  const handleClickNextButton = () => onSelectPageNumber(currentPageNumber + 1);

  return {
    showPrevPageButton,
    showNextPageButton,
    isShowComponent,
    summaryLabel,
    visiblePages,
    totalPages,
    handleClickPrevButton,
    handleClickNextButton,
  };
};

export default useBusinessLogic;
